import styled from 'styled-components';

import { addMeasureType } from '../../../utils';

export const CompContainer = styled.div<{ $marginTop?: number }>`
  display: flex;
  justify-content: center;
  margin-top: ${({ $marginTop = 0 }) => addMeasureType($marginTop)};
`;

export const ButtonsBox = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const Btn = styled.button`
  border: 0;
  outline: none;
  background: transparent;
  padding: 0;
  display: block;
`;

export const ArrBtnLeft = styled(Btn)<{$isVisible: boolean}>`
  margin-right: 30px;
  visibility: ${({ $isVisible }) => ($isVisible ? 'visible' : 'hidden')};
`;
ArrBtnLeft.displayName = 'ArrBtnLeft';

export const ArrBtnRight = styled(Btn)<{$isVisible: boolean}>`
  margin-left: 25px;
  visibility: ${({ $isVisible }) => ($isVisible ? 'visible' : 'hidden')};
`;
ArrBtnRight.displayName = 'ArrBtnRight';

export const PageBtn = styled(Btn)`
  color: ${({ theme }) => theme.baseBlue.a6};
  font-size: 1rem;
  font-weight: normal;
  padding: 2px 5px;
  cursor: pointer;
  margin-right: 5px;

  &:hover {
    text-decoration: underline;
    color: ${({ theme }) => theme.baseBlue.a10};
  }

  &.cur {
    text-decoration: none;
    font-weight: 600;
    color: ${({ theme }) => theme.baseBlue.a10};
    cursor: default;
  }
`;
PageBtn.displayName = 'PageBtn';

export const DotsBox = styled.div`
  margin-right: 5px;
`;
DotsBox.displayName = 'DotsBox';
